import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const FacebookLoginButton = ({ clientId }) => {
  const navigate = useNavigate();

  const handleFacebookLogin = () => {
    window.FB.login(function(response) {
      if (response.authResponse) {
        // Função não assíncrona para processar o login
        const processLogin = () => {
          axios.post(`/api/clients/${clientId}/meta/fb-login`, {
            accessToken: response.authResponse.accessToken,
            userID: response.authResponse.userID
          })
          .then(result => {
            if (result.data.status === 'success') {
              localStorage.setItem('token', result.data.token);
              navigate('/dashboard');
            }
          })
          .catch(error => {
            console.error('Erro ao processar login do Facebook:', error);
            alert('Erro ao fazer login com Facebook. Por favor, tente novamente.');
          });
        };
        
        processLogin();
      } else {
        console.log('Usuário cancelou login ou não autorizou completamente.');
      }
    }, {scope: 'public_profile,email'});
  };
  
  return (
    <button 
      onClick={handleFacebookLogin}
      className="facebook-login-btn"
      style={{
        backgroundColor: '#1877F2',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '10px 15px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px'
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white">
        <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C18.34 21.21 22 17.06 22 12.06C22 6.53 17.5 2.04 12 2.04Z" />
      </svg>
      Entrar com Facebook
    </button>
  );
};

export default FacebookLoginButton;
